export const SEGMENT_RATE_MAX = 100;

export const SEGMENT_RATE_ERROR = 'Entre 0 et 100, deux décimales au plus';

const SEGMENT_RATE_PATTERN = /^\d+(\.\d{1,2})?$/;

export const isSegmentRateValid = (rate: string): boolean =>
  SEGMENT_RATE_PATTERN.test(rate) && Number(rate) <= SEGMENT_RATE_MAX;
